import { RichTextRenderer } from '@contember/react-client'
import type { FunctionComponent } from 'react'
import style from './Wysiwyg.module.sass'

export type WysiwygProps = {
	children?: React.ReactNode
	source?: string
}

export const Wysiwyg: FunctionComponent<WysiwygProps> = ({ source, children }) => {
	return (
		<div className={style.wrapper}>{source ? <RichTextRenderer source={source} /> : children}</div>
	)
}
